<script setup lang="ts">
import type { ItpDataGridColumn } from './types';
import { columnKey } from './gridCell';

withDefaults(
  defineProps<{
    columns: ItpDataGridColumn[];
    gridTemplateColumns: string;
    drafts: Record<string, string>;
    isFilterable: (field: string) => boolean;
    hasSystemColumn?: boolean;
  }>(),
  { hasSystemColumn: false },
);

defineEmits<{ input: [field: string, value: string] }>();
</script>

<template>
  <div class="itp-data-grid__filterrow" :style="{ gridTemplateColumns }">
    <div
      v-if="hasSystemColumn"
      class="itp-data-grid__filtercell itp-data-grid__syscell"
    />
    <div
      v-for="column in columns"
      :key="columnKey(column)"
      class="itp-data-grid__filtercell"
    >
      <input
        v-if="isFilterable(columnKey(column))"
        type="search"
        class="itp-data-grid__filterinput"
        :class="{ 'has-value': drafts[columnKey(column)] }"
        :value="drafts[columnKey(column)] ?? ''"
        :placeholder="column.name || column.field"
        @input="
          $emit(
            'input',
            columnKey(column),
            ($event.target as HTMLInputElement).value,
          )
        "
      />
    </div>
  </div>
</template>
